<template>
  <div v-if="message" class="tip">
    <span class="triangle" />
    <div v-sanitize-html="message">
      {{ message }}
    </div>
  </div>
</template>

<script>
/**
 * @deprecated - reach out to @shady356 for a replacement
 */
export default {
  props: {
    message: {
      type: [String, null],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.tip {
  position: relative;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 700;
  color: $color-canvas;
  padding: 8px;
  border-radius: 4px;
  width: 100%;
}

.tip .triangle {
  position: absolute;
  top: -10px;
  right: 16.5px;
  width: 10px;
  height: 10px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.tip.warning .triangle {
  border-bottom: 5px solid $color-error;
}

.tip.info .triangle {
  border-bottom: 5px solid $color-text;
}

.tip.warning {
  background: $color-error;
}

.tip.info {
  background: $color-text;
}
</style>
